import React, { useState } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const srcVirtual =
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ02xP1rAqhrXjDkFUSaoZWgYdlfRgmJdLC6qaMOltc-PD4B8RYzdu4Btj22ikVjPULhkdPx811A?gv=true';
const srcLlamada =
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ2sk_tefYhbbHAKLRlEIMYC43DMOStyHZ0AISVvL8XN05VRebotjp0iwnqT1vMfyNgtzvSc1Wpt?gv=true';
const srcPresencial =
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ00zx_s32RMzOp7ZENsTeiBGBZik48o_Ljmw-qpPOual8zSAlLdPAFJ6eobSihKSUY1yWAkDmUk?gv=true';

const Contacto = () => {
  const [ref, isVisible] = useScrollAnimation();
  const [tipo, setTipo] = useState('virtual');

  const iframeSrc =
    tipo === 'virtual' ? srcVirtual : tipo === 'llamada' ? srcLlamada : srcPresencial;
  const iframeTitle =
    tipo === 'virtual'
      ? 'Reunión virtual (Google Calendar)'
      : tipo === 'llamada'
        ? 'Llamada (Google Calendar)'
        : 'Reunión presencial (Google Calendar)';

  const tabStyle = (active) => ({
    backgroundColor: active ? '#1e3a5f' : '#e5e7eb',
    color: active ? '#ffffff' : '#1e3a5f',
    borderRadius: '999px',
    padding: '0.5rem 1rem',
    fontWeight: 600,
  });

  return (
    <section id="contacto" className="py-5 bg-light">
      <div className="container" ref={ref}>
        <h2
          className={`text-center mb-4 mb-lg-5 fw-bold titulo-seccion-desktop contacto-habla-titulo ${isVisible ? 'animate-fade-in' : ''}`}
        >
          Habla con nosotros
        </h2>
        <div className={`row g-4 ${isVisible ? 'animate-fade-in' : ''}`}>
          <div className="col-lg-12">
            <div
              className="bg-white h-100"
              style={{
                padding: '2rem 1.5rem',
                paddingLeft: '1rem',
                paddingRight: '1rem',
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              }}
            >
              <h2
                className="fw-bold mb-3 text-center contacto-agenda-titulo"
                style={{ fontSize: '1.75rem', color: '#1e3a5f' }}
              >
                <i className="bi bi-calendar-check me-2"></i>
                Agendá tu cita o llamada
              </h2>
              <p className="text-muted text-center mb-4 small">
                Seleccioná el tipo de atención y luego el día/horario
              </p>

              <div
                className="d-flex gap-2 justify-content-center mb-3 flex-wrap"
                role="tablist"
                aria-label="Tipo de atención"
              >
                <button
                  type="button"
                  className="btn btn-sm"
                  onClick={() => setTipo('virtual')}
                  style={tabStyle(tipo === 'virtual')}
                  role="tab"
                  aria-selected={tipo === 'virtual'}
                >
                  Reunión virtual
                </button>
                <button
                  type="button"
                  className="btn btn-sm"
                  onClick={() => setTipo('llamada')}
                  style={tabStyle(tipo === 'llamada')}
                  role="tab"
                  aria-selected={tipo === 'llamada'}
                >
                  Llamada
                </button>
                <button
                  type="button"
                  className="btn btn-sm"
                  onClick={() => setTipo('presencial')}
                  style={tabStyle(tipo === 'presencial')}
                  role="tab"
                  aria-selected={tipo === 'presencial'}
                >
                  Reunión presencial
                </button>
              </div>

              <div className="rounded-3 overflow-hidden border border-light shadow-sm" style={{ width: '100%' }}>
                <iframe
                  key={tipo}
                  title={iframeTitle}
                  src={iframeSrc}
                  style={{ border: 0, width: '100%', height: '600px', display: 'block' }}
                  width="100%"
                  height="600"
                  frameBorder={0}
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacto;
